export default {
    routerName: 'ログイン',
    user: {
        loginName: 'アカウント',
        password: 'パスワード',
        captcha: 'キャプチャ',
    },
};
